// Two-coach calls (coachs-box docs/TWO_COACH_CONTRACT.md on the staging branch).
// The server computes coverage; the grid only renders it.
import { dataInstance } from "./axiosInstance";

// GET /api/events/coverage?start_date&end_date (inclusive, gym-local YYYY-MM-DD).
// Returns { classes: [{ key, start, end, duration, class_type, type, capacity,
// coverage: "open" | "half" | "full", is_past, recurring, roles: [...] }], open_roles }
export async function fetchCoverage({ startDate, endDate }) {
  const { data } = await dataInstance.get("/events/coverage", {
    params: { start_date: startDate, end_date: endDate },
  });
  return data;
}

// Gym-local naive ISO ("2026-10-06T17:15:00") plus minutes, without going
// through the browser's timezone so a phone set to another zone still works.
export function addMinutesToLocalIso(localIso, minutes) {
  const [datePart, timePart] = localIso.split("T");
  const [y, mo, d] = datePart.split("-").map(Number);
  const [h, mi] = timePart.split(":").map(Number);
  const t = new Date(Date.UTC(y, mo - 1, d, h, mi + minutes));
  const pad = (n) => String(n).padStart(2, "0");
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}T${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}:00`;
}

// POST /api/events/claim-event for one role of a coverage class. `role` is
// null on a one-coach class. `coachName` is the coach's first name, the same
// way the grid has always claimed (admins pick any coach, coaches pass their own).
export async function claimRole({ cls, role, coachName }) {
  const body = {
    class_type: cls.type || cls.class_type,
    recurring: cls.recurring !== false,
    start_time: cls.key,
    end_time: addMinutesToLocalIso(cls.key, cls.duration),
    coach_name: coachName,
    role: role || null,
  };
  const { data } = await dataInstance.post("/events/claim-event", body);
  return data;
}

// DELETE /api/events/unclaim-event/:eventId
export async function releaseRole(eventId) {
  const { data } = await dataInstance.delete(`/events/unclaim-event/${eventId}`);
  return data;
}

// PATCH /api/admin/time-slots: set 1 or 2 coaches on some of a recurring
// slot's weekdays. `time` is "05:15 PM", `classType` the slot type as stored.
export async function setSlotCoachCount({ time, classType, days, coachCount }) {
  const { data } = await dataInstance.patch("/admin/time-slots", {
    time,
    class_type: classType,
    days,
    coach_count: coachCount,
  });
  return data;
}

// The human message from a FastAPI error ({ detail }), or a fallback.
export function apiErrorMessage(error, fallback = "Something went wrong.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail.detail === "string") return detail.detail;
  if (detail && typeof detail.message === "string") return detail.message;
  return fallback;
}
